export default function me(state = {}, {type,data}) {
  switch(type) {
    case 'user select':
      return {...data}
    case 'level set':
      return {...state,selectedLevel:data}
    case 'cid update':
      return {...state,cid:data}
    default:
      return state
  }
}



/** WEBPACK FOOTER **
 ** ./src/app/reducers/me.js
 **/